import styled, { css } from 'styled-components';

export const H3TextContainer = styled.div`
    font-family: "museo sans";
    font-weight: 700;
    font-size: 28px;
    line-height: 36px;
    
    ${props => css`
        color: ${props.color}
    `}




`;